import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Collapse, Group, Loader, Stack, Text, ThemeIcon, Paper, ScrollArea, Divider } from "@mantine/core";
import { IconBox, IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import cx from "clsx";

import { ListAssetDto } from "../../models/assets.models";
import classes from "./AssetList.module.css";

interface ChildAssetsListProps {
	childAssets?: ListAssetDto[] | null;
	isLoading?: boolean;
}

export const ChildAssetsList = ({ childAssets, isLoading }: ChildAssetsListProps) => {
	const [isOpen, setIsOpen] = useState(false);

	if (!childAssets || childAssets.length === 0) {
		return null;
	}

	return (
		<Stack gap={0} mb="lg">
			<Divider mb="md" />
			<Group
				justify="space-between"
				py="sm"
				onClick={() => setIsOpen(!isOpen)}
				style={{ cursor: "pointer", marginTop: "md", marginBottom: isOpen ? "md" : 0 }}
			>
				<Group gap={8}>
					<Text fz="xs" fw="700" tt="uppercase" c="dimmed">
						Child Assets ({childAssets.length})
					</Text>
				</Group>
				{isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
			</Group>

			<Collapse in={isOpen}>
				{isLoading ? (
					<Loader size="sm" ml="md" />
				) : (
					<Paper p={0} radius="md" style={{ overflow: "hidden" }}>
						<Stack gap={0}>
							{childAssets.map((child) => (
								<Button
									key={child.AssetId}
									component={Link}
									to={`/assets/${child.AssetId}`}
									className={cx(classes["asset-list-item"])}
									w="100%"
									leftSection={
										<ThemeIcon radius="xl" color="blue" size="xl" style={{ border: "1px solid var(--mantine-color-default-border)" }} variant="light">
											<IconBox size={24} />
										</ThemeIcon>
									}
								>
									<Stack gap={2} align="flex-start">
										<Text fw={500}>{child.Name}</Text>
										{(child.AssetType || child.Location?.Title) && (
											<Text fz="xs" c="dimmed">
												{child.AssetType || ""}{child.AssetType && child.Location?.Title ? " - " : ""}{child.Location?.Title || ""}
											</Text>
										)}
									</Stack>
								</Button>
							))}
						</Stack>
					</Paper>
				)}
			</Collapse>
		</Stack>
	);
};
